import { render, staticRenderFns } from "./validatedForm.vue?vue&type=template&id=85c6292a&"
import script from "./validatedForm.vue?vue&type=script&lang=js&"
export * from "./validatedForm.vue?vue&type=script&lang=js&"
import style0 from "./validatedForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports